export default __webpack_public_path__ + "static/media/DE-Logo-PassengerApp.f3778000.png";